import React from 'react';
export function StarterSetContent() {
  const bonuses = [{
    title: 'Premium Creatin Creapure®',
    description: 'Du willst beim Training und im Alltag alles geben – und deinem Körper genau das bieten, was er braucht? Unser Premium Creatin Monohydrat Markenrohstoff ist dein täglicher Support für mehr Power, mehr Muskelleistung und mehr du.'
  }, {
    title: 'Premium Shaker',
    description: 'Mit diesem Shaker wird dein Shake lecker! Denn jetzt speziell entwickelte Gitter sorgt dafür, dass sich Klümpchen auflösen und der Proteinshake schön schaumig-cremig wird. Wie ein richtiger Milchshake eben! Er ist klein, kompakt und praktisch. So kannst du dich voll und ganz auf den köstlichen Geschmack konzentrieren. Lass es dir schmecken!'
  }, {
    title: 'Rezeptbuch "Nourish"',
    description: 'Mit diesem Buch erhältst du eine tolle Starthilfe für deinen eve-Weg mit vielen wertvollen Tipps & Infos. Hinzu kommen jede Menge Rezepte für herzhafte und süße Hauptmahlzeiten sowie Snacks. Und das Highlight: Dein persönliches Ernährungstagebuch für einen Monat zum Ausfüllen!'
  }];
  const flavors = ['Nourishing Vanilla (mit echter Vanille)', 'Divine Cocoa (cremiger Kakao)', 'Simply Neutral (ohne Geschmack, vielseitig einsetzbar)', 'Matcha Bliss (mit grünem Matcha-Tee)'];
  const socialMediaPosts = ['https://uploadthingy.s3.us-west-1.amazonaws.com/6GufbDgSiG3Kjh3qp9GL4M/Screenshot_2025-10-14_at_16.23.44.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/eMkHv6A72GcA241aDq26dQ/Screenshot_2025-10-14_at_16.24.17.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/qowXcWmmS5cPEHGFicWs8h/Screenshot_2025-10-14_at_16.24.28.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/x8PJNuhgKaALH34vvHAHXz/Screenshot_2025-10-14_at_16.25.11.png'];
  return <section className="py-16 bg-gray-50" data-id="element-237">
      <div className="max-w-4xl mx-auto" data-id="element-238">
        <div className="text-center mb-12" data-id="element-239">
          <span className="inline-block bg-emerald-100 text-emerald-700 text-sm font-medium py-1 px-3 rounded-full mb-3" data-id="element-240">
            Dein Starter-Set
          </span>
          <h3 className="text-4xl font-bold text-gray-800" data-id="element-241">
            Das 6-Wochen Starter-Set + 2 GRATIS Geschenke
          </h3>
        </div>
        <div className="bg-white rounded-xl shadow-md p-8 mb-12 border border-gray-100" data-id="element-242">
          <div className="flex items-center mb-6" data-id="element-243">
            <div className="bg-emerald-600 h-10 w-10 rounded-full flex items-center justify-center mr-4 text-white font-bold" data-id="element-244">
              1
            </div>
            <h4 className="text-xl font-semibold text-emerald-700" data-id="element-245">
              3 Beutel eve nutrition Proteinpulver
            </h4>
          </div>
          <p className="text-gray-700 mb-6 pl-14" data-id="element-246">
            Probiere dich durch die Vielfalt der vielen Geschmacksrichtungen von
            eve nutrition: So bist du für motivierende Erfolge innerhalb nur 6
            Wochen gewappnet.
          </p>
          <div className="bg-emerald-50 p-6 rounded-xl mb-8 border border-emerald-100" data-id="element-247">
            <h5 className="font-medium text-gray-800 mb-4" data-id="element-248">
              Geschmacksrichtungen zur Auswahl:
            </h5>
            <ul className="space-y-3" data-id="element-249">
              {flavors.map((flavor, index) => <li key={index} className="flex items-center text-gray-700" data-id="element-250">
                  <span className="w-3 h-3 bg-emerald-500 rounded-full mr-3" data-id="element-251"></span>
                  <span className="font-medium" data-id="element-252">{flavor}</span>
                </li>)}
            </ul>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-253">
            <div className="rounded-lg h-48 overflow-hidden shadow-sm" data-id="element-254">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ksnhWSSPrL4nYh1PCthqNN/nano-banana-2025-10-14T14-41-54.png" alt="eve nutrition Simply Neutral Proteinpulver" className="w-full h-full object-cover" data-id="element-255" />
            </div>
            <div className="rounded-lg h-48 overflow-hidden shadow-sm" data-id="element-256">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qS5bdbocnhaEPFsrgczQMR/nano-banana-2025-10-14T14-39-15.png" alt="eve nutrition Divine Cocoa Proteinpulver" className="w-full h-full object-cover" data-id="element-257" />
            </div>
            <div className="rounded-lg h-48 overflow-hidden shadow-sm" data-id="element-258">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mm8kTDHeoN4At29UUNDbZP/nano-banana-2025-10-14T09-44-37_%281%29.png" alt="eve nutrition Nourishing Vanilla Proteinpulver" className="w-full h-full object-cover" data-id="element-259" />
            </div>
          </div>
        </div>
        
        <div className="bg-white rounded-xl shadow-md p-8 mb-12 border border-gray-100" data-id="element-260">
          <h4 className="text-2xl font-bold text-emerald-700 mb-6" data-id="element-261">
            eve nutrition Starter-Set
          </h4>
          <ul className="space-y-4" data-id="element-262">
            <li className="flex items-start" data-id="element-263">
              <span className="w-2 h-2 bg-emerald-600 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-264"></span>
              <span className="text-gray-700 font-medium" data-id="element-265">
                3 Packungen Bestseller Proteinpulver eve Nourishing Vanilla
              </span>
            </li>
            
            <li className="flex items-start" data-id="element-266">
              <span className="w-2 h-2 bg-emerald-600 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-267"></span>
              <span className="text-gray-700 font-medium" data-id="element-268">
                GRATIS: 1 Rezeptbuch - von Ernährungsberatern empfohlen
              </span>
            </li>
          </ul>
        </div>
        <div className="space-y-8" data-id="element-269">{bonuses.map((bonus, index) => {})}</div>
        <div className="mt-12 text-center mb-12" data-id="element-270">
          <a href="https://weesesumecontasy.com/click/2" className="inline-block" data-id="element-271">
            <button className="bg-emerald-600 hover:bg-emerald-700 text-white font-bold py-4 px-10 rounded-full transition duration-300 shadow-md text-lg" data-id="element-272">
              Zum Starter-Set Angebot
            </button>
          </a>
          <p className="text-sm text-gray-500 mt-3" data-id="element-273">
            Inkl. kostenlosem Versand & 30 Tage Geld-zurück-Garantie
          </p>
        </div>
        <div className="bg-emerald-50 p-8 rounded-xl text-center border border-emerald-100 shadow-sm" data-id="element-274">
          <div className="inline-block bg-white p-2 rounded-full mb-4 shadow-sm" data-id="element-275">
            <svg className="w-8 h-8 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-276">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-277" />
            </svg>
          </div>
          <h4 className="text-xl font-semibold text-gray-800 mb-3" data-id="element-278">
            Geld-zurück-Garantie
          </h4>
          <p className="text-gray-700 mb-4" data-id="element-279">
            eve nutrition legt höchsten Wert auf Kundenzufriedenheit!
          </p>
          <p className="text-gray-700 font-medium" data-id="element-280">
            Wenn du mit dem eve Bundle unzufrieden bist, kannst du es innerhalb
            von 30 Tagen nach Versand zurückgeben. Ganz einfach!
          </p>
        </div>
      </div>
    </section>;
}